import { LoggingService } from '../services/logging';

const log = new LoggingService();
// this is the best way to handle accordion open/close
// baseheight may need adjustment depending on anything outside the tabs
export function handleOnOpen(
    $event: number[],
    baseHeight: number,
    tabHeight: string
) {
    log.verbose({
        type: 'shared:handleOnOpen',
        $event,
        activeState: this.activeState
    });
    tabHeight = `${
        baseHeight / ($event && $event.length ? $event.length : 1) - 1
    }vh`;
    //     setTimeout(() => {
    //         window.dispatchEvent(new Event('resize'));
    //     }, 0);
}
